import { UnionMap } from '../types/union-map';

// TODO: Task 2443329: Update add-ons to use Data plane SDK package when available
export type DevBoxHyperVProvisioningState = 'Creating' | 'Deleting' | 'Unknown' | 'Succeeded' | 'Failed';

export const DevBoxHyperVProvisioningState: UnionMap<DevBoxHyperVProvisioningState> = {
    Creating: 'Creating',
    Deleting: 'Deleting',
    Unknown: 'Unknown',
    Succeeded: 'Succeeded',
    Failed: 'Failed',
};

// TODO: Task 2443326: Replace pool URI with actual 1ES pool URI
// Using Briana's EUAP pool for now
export const HyperVDogfoodingPoolUri =
    'https://72f988bf-86f1-41af-91ab-2d7cd011db47-ally-euap-dc.centraluseuap.devcenter.azure.com/projects/breng-project-euap/pools/testpool';

export const HyperVDogfoodingInstructionsLink = 'https://aka.ms/devbox/linuxdogfooding/instructions ';

export const LinuxName = 'Linux';
